import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const analysisPhase = new Paragraph({
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "Analysis Phase",
            size: 22,
            color: "c00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false
        })
    ],
})

export const analysisPhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "All the identified information security gaps are then assimilated/validated by performing testing on the systems and its related Application.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const admittancePhase = new Paragraph({
    spacing: { before: 250 },
    children: [
        new TextRun({
            text: "Admittance Phase",
            size: 22,
            color: "c00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false
        })
    ],
})

export const admittancePhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "During this phase the ISECURION Consultants exploit the vulnerabilities found in the previous phase and document the evidence.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const affirmationPhase = new Paragraph({
    spacing: { before: 250 },
    children: [
        new TextRun({
            text: "Affirmation Phase",
            size: 22,
            color: "c00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false
        })
    ],
})

export const affirmationPhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "A detailed Assessment report is prepared and submitted to the application owner/client.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

